<template>
  <section id="invite-players">
    <b-modal v-model="isOpen" :width="640">
      <div class="p-4" style="background-color: #fff;">
        <!-- Search box -->
        <b-field class="my-0 search-field">
          <b-input
            v-model="filterText"
            placeholder="Type to search players"
            type="search"
            icon="search"
          ></b-input>
        </b-field>

        <div class="mt-5">
          <b-table
            :data="availablePlayers.length ? availablePlayers : []"
            :hoverable="true"
            :focusable="true"
            style="width: 100%"
          >
            <b-table-column
              field="name"
              cell-class="has-text-left"
              v-slot="{ row: player }"
            >
              <ProfileCard
                :player="player"
                :rating="player.stats ? player.stats.rating : null"
                :onlinePlayer="player"
              />
            </b-table-column>
            <b-table-column
              field="name"
              cell-class="has-text-right"
              v-slot="{ row: player }"
            >
              <b-button
                size="is-small"
                icon-left="paper-plane"
                :type="
                  isInvited(player)
                    ? isAccepted(player)
                      ? 'is-primary'
                      : 'is-danger'
                    : 'is-info'
                "
                @click="
                  isInvited(player)
                    ? isAccepted(player)
                      ? null
                      : cancel(player)
                    : isOnline(player)
                    ? invite(player)
                    : add(player)
                "
              >
                {{
                  isInvited(player)
                    ? isAccepted(player)
                      ? "Accepted"
                      : "Cancel"
                    : isOnline(player)
                    ? "Invite"
                    : "Add"
                }}
              </b-button>
            </b-table-column>

            <template #empty>
              No player found
            </template>
          </b-table>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import ProfileCard from "@/components/players/ProfileCard.vue";
import { database } from "@/services/firebase";
import { CHALLENGE_STATUS } from "@/constants";
import { PlayersAPI, MatchesAPI } from "@/services/api";

export default {
  components: { ProfileCard },

  name: "AddOrInvitePlayers",

  props: {
    excluded: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isOpen: false,
      filterText: "",
      receiver: null,
      foundPlayers: [],
    };
  },

  watch: {
    filterText: {
      handler: _.debounce(async function() {
        console.log(333, this.filterText);
        this.foundPlayers = await this.queryPlayers(this.filterText);
        this.foundPlayers = this.foundPlayers.filter(
          (p) => p.user_id !== this.currentPlayer.user_id
        );
      }, 250),
    },
  },

  computed: {
    ...mapGetters({
      currentPlayer: "getPlayer",
      lobbyPlayers: "getOnlinePlayers",
    }),

    findByUsername() {
      return !isNaN(this.filterText.slice(-4));
    },

    availablePlayers() {
      if (!this.lobbyPlayers || !this.lobbyPlayers.length) return [];

      const onlineFiltered = this.lobbyPlayers.filter(
        (p) =>
          !p.challenge ||
          (p.challenge &&
            p.challenge.player.user_id === this.currentPlayer.user_id)
      );

      if (!this.filterText) {
        return onlineFiltered;
      }

      if (this.findByUsername) {
        // last 4 digits is a number, so it's an username, find from database
        return this.foundPlayers.filter(
          (p) => !this.excluded.includes(p.user_id)
        );
      } else {
        // last 4 digits is not number, so not an username, find online users only
        return onlineFiltered.filter(
          (player) =>
            player.name.toLowerCase().includes(this.filterText.toLowerCase()) ||
            player.username === this.filterText.toLowerCase()
        );
      }
    },
  },

  methods: {
    open() {
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
    },

    isOnline(player) {
      if (!player || !player.user_id) return false;
      if (!this.lobbyPlayers || !this.lobbyPlayers.length) return false;
      return !!this.lobbyPlayers.find((p) => p.user_id === player.user_id);
    },

    isAdded(player) {
      return !!player.challenge;
    },

    isAccepted(player) {
      return player.challenge.status === CHALLENGE_STATUS.ACCEPTED;
    },

    isInvited(player) {
      return !!player.challenge;
    },

    invite(player) {
      this.$emit("onInvite", player);
    },

    add(player) {
      this.$emit("onAdd", player);
    },

    async cancel(player) {
      await database
        .ref(`rooms/lobby/players/${player.user_id}/challenge`)
        .remove();
    },

    async queryPlayers(username) {
      let player = await PlayersAPI.getPlayer(username);
      if (!player) {
        return [];
      }
      const stats = await MatchesAPI.getPlayerRating(username);
      player = { ...player, stats };

      return [player];
    },
  },
};
</script>

<style scoped>
.search-field {
  position: absolute;
  width: calc(100% - 2rem);
  z-index: 1;
}
</style>
